import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { LaddaModule } from 'angular2-ladda';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { nameValidator } from '../../core/validators/nameValidator';
import { phoneNumberValidator } from '../../core/validators/phoneValidators';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-detalle',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    LaddaModule,
  ],
  providers: [
    provideNgxMask()
  ],
  templateUrl: './detalle.component.html',
  styleUrl: './detalle.component.scss'
})
export class DetalleComponent {

  isBrowser: boolean = false;

  isLoading: boolean = false;

  formFacturacion!: UntypedFormGroup;

  uniqueIdSaved: string = ''

  nombrePaquete: string = 'Paquete de suscripción Premium';
  price = 99.99
  descuento: number = 0
  private cantidad = 1
  private iva = 15

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    
    this.isBrowser = isPlatformBrowser(this.platformId);

    this.formFacturacion = new FormGroup<any>({
      identificacion: new FormControl('', { validators: [Validators.required, Validators.pattern('[+()0-9]{10}')]}),
      nombres: new FormControl('',{ validators: [Validators.required, nameValidator()] }),
      apellidos: new FormControl('',{ validators: [Validators.required, nameValidator()]}),
      correo: new FormControl('',{ validators: [Validators.required, Validators.email]}),
      direccion: new FormControl('', { validators: [ Validators.required, nameValidator() ]}),
      telefono: new FormControl('', { validators: [ Validators.required, Validators.pattern('[- +()0-9]{10}'), phoneNumberValidator() ]}),
    })

  }

  get f() { return this.formFacturacion.controls; }

  getSubtotal(): number {
    return (this.cantidad * this.price) - this.descuento;
  }

  getIva(): number {
    let subtotal = this.getSubtotal();
    return this.iva == 0 ? 0 : ((subtotal) * this.iva) / 100; 
  }

  getTotal(): number {
    let subtotal = this.getSubtotal();
    let iva = this.getIva() 
    return subtotal + iva;
  }

  reference(): string {
    return 'PAQUETE-SUBSCRIPCION-PREMIUM-2025'
  }

  uniqueId = (prefix: string)  => {
    var id = this.formatIp() + '-'+ this.formatDate() + '-' + Math.floor(Math.random() * 1000);
    return prefix ? prefix + '-' + id : id;
  };

  formatDate() {
    const date = new Date()
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const milliseconds = String(date.getMilliseconds()).padStart(4, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}${milliseconds}`;
  }

  formatIp() {
    return '192.168.1.1'
    // return !!VariablesGlobales._idEquipo? VariablesGlobales._idEquipo.replaceAll(/\./g, '') : ''
  }

  loadScriptPayphone() {
    const scriptId = 'payphone-script';
    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://pay.payphonetodoesposible.com/api/button/js?appId=${environment.payphoneAppId}`;
    script.defer = true;
    script.onload = () => {
      this.initPayphone();
    };
    document.body.appendChild(script);
  }

  initPayphone() {
    // Inicializar el botón de pago una vez que el script se haya cargado
    if ((window as any).PPaymentButtonBox) {
      if(this.getIva() == 0 ) {
        new (window as any).PPaymentButtonBox({
          token: environment.payphoneToken,
          clientTransactionId: this.uniqueIdSaved, 	
          amount: ( Number(this.getTotal().toFixed(0)) * 100), 
          amountWithTax: ( Number(this.getSubtotal().toFixed(0)) * 100), 
          currency: "USD",
          storeId: environment.payphoneStore, 
          reference: this.reference(),
          btnHorizontal: true,
          callButtonText: 'Pagar con PayPhone'
        }).render('buttonPago');
      } else {
        new (window as any).PPaymentButtonBox({
          token: environment.payphoneToken,
          clientTransactionId: this.uniqueIdSaved, 	
          amount: ( Number(this.getTotal().toFixed(0)) * 100), 
          amountWithTax: ( Number(this.getSubtotal().toFixed(0)) * 100), 
          tax: Number(this.getIva().toFixed(2)) * 100,
          currency: "USD",
          storeId: environment.payphoneStore,
          reference: this.reference(),
          btnHorizontal: true,
          callButtonText: 'Pagar con PayPhone'
        }).render('buttonPago');
      }
    }
  }

  onSubmit() {
    if(this.formFacturacion.enabled) {
      this.isLoading = true
      this.uniqueIdSaved = this.uniqueId('transaccion')
      setTimeout(() => {
        this.isLoading = false
        this.formFacturacion.disable()
        this.loadScriptPayphone()
      }, 5000)
      console.log(this.formFacturacion.value)
      // this.apiService.useApiServive(PayphoneResponse.post(this.formFacturacion.value, this.uniqueIdSaved, this.productoSeleccionado, this.cantidad)).subscribe({
      //   next: (response: any) => {

      //     setTimeout(() => {
      //       console.log('response', response)
      //       this.formFacturacion.disable()
      //       this.loadScriptPayphone()
      //       this.isLoading = false
      //     }, 5000)
      //   },
      //   error: (error: any) => {
      //     setTimeout(() => {
      //       console.log('error', error)
      //       this.formFacturacion.disable()
      //       this.loadScriptPayphone()
      //       this.isLoading = false
      //     }, 5000)
      //     // this.isLoading = false
      //   }
      // })
      
    } 
  }

  letterOnlyValidator(event: any) {
    const input = event.target.value;

    const pattern = /^[A-Za-záéíóúÁÉÍÓÚñÑ\s]*$/;

    if (!pattern.test(input)) {
      if ( /\d/.test(input) ) { // validadmos si hay numeros 
        event.target.value = input?.trim().slice(0, -1) // Elimina el último carácter no válido
      } else {
        event.target.value = input == ' '? '' : input.replace(/  +/g, ' '); 
      }
    } else {
      event.target.value = input == ' '? '' : input.replace(/  +/g, ' ');
    }
  }

  idOnlyValidator(event: any) {
    const pattern = /^[0-9\-]*$/;
    let val = event.target.value;
    if (!pattern.test(val)) {
      val = val.replace(/[^0-9\-]/g, "");
      event.target.value = val
    } else {
      if(val.length > 10) {
        val = val.substr(0, 10);
        this.formFacturacion.controls["identificacion"].setErrors(null);
      }
      event.target.value = val
    }
  }

}
